import { render, staticRenderFns } from "./StampCardRecord.vue?vue&type=template&id=1c60e01c&"
import script from "./StampCardRecord.vue?vue&type=script&lang=js&"
export * from "./StampCardRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports